import { Typography } from "@mui/material";
import React, { useEffect } from "react";
import styles from "./PaymentPrompt.module.css";
import AppButton from "component/button/AppButton";
import { convertToLocaleString } from "utils/helpers";
import InfoIcon from "component/infoIcon/InfoIcon";
import { useForm } from "react-hook-form";
import { v4 as uuidv4 } from "uuid";

function PaymentPrompt({
  selectedApplication,
  handlePayment,
  handlePaymentZest,
  setOpenPaymentPrompt,
}) {
  //const { register, setValue } = useForm();


  // useEffect(()=>{
  //   setValue('site_redirect_url', `${process.env.REACT_APP_BASE_URL}/verify`)
  //   setValue('merchant_code',process.env.REACT_APP_INTERSWITCH_MERCHANT_CODE)
  //   setValue('pay_item_id',process.env.REACT_APP_INTERSWITCH_PAY_ITEM)
  //   setValue('amount', selectedApplication.payments.total * 100)
  //   setValue('txn_ref', uuidv4())
  // }, [selectedApplication])

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
      }}
      className={styles.credit_check}
    >
      <>
        <div className={styles.icon}>
          <InfoIcon />
        </div>
        <div className={styles.text}>
          <Typography variant="h6">Information</Typography>
          <Typography>
            You would be redirected to a payment portal to make payments for the
            following fees:
          </Typography>
        </div>
        <div className={styles.payment}>
          <div className={styles.item}>
            <Typography variant="h6">Search price</Typography>
            <Typography>
              ₦{" "}
              {convertToLocaleString(
                selectedApplication?.payments?.searchPrice
              )}
            </Typography>
          </div>
          <div className={styles.item}>
            <Typography variant="h6">Valuation price</Typography>
            <Typography>
              ₦{" "}
              {convertToLocaleString(
                selectedApplication?.payments?.valuationPrice
              )}
            </Typography>
          </div>
          <div className={styles.item}>
            <Typography variant="h6">Verification price</Typography>
            <Typography>
              ₦{" "}
              {convertToLocaleString(
                selectedApplication?.payments?.verificationPrice
              )}
            </Typography>
          </div>
          <div className={`${styles.item} ${styles.item_last}`}>
            <Typography variant="h6">Total</Typography>
            <Typography>
              ₦ {convertToLocaleString(selectedApplication?.payments?.total)}
            </Typography>
          </div>
        </div>
        <div className={styles.text}>
          <Typography>Click proceed if you wish to continue.</Typography>
        </div>

        <div className={styles.btns}>
          <div className={styles.btn}>
            <AppButton
              border={"1px solid #0089FF"}
              bRadius="6px"
              handleAction={() => {
                setOpenPaymentPrompt(false);
              }}
              width={"146px"}
              textColor="#fff"
              btnBg="#CE0000"
              btnText={"Close"}
            />
          </div>
          <div className={styles.btn}>
              <AppButton
                bRadius="6px"
                handleAction={() => {
                  handlePaymentZest();
                }}
                width={"146px"}
                textColor="#FFFFFF"
                btnBg="#02bf01"
                btnText={"Proceed with Zest"}
              />
            </div>

          <div className={styles.btn}>
              <AppButton
                bRadius="6px"
                handleAction={() => {
                  handlePayment();
                }}
                width={"146px"}
                textColor="#FFFFFF"
                btnBg="#17425d"
                btnText={"Proceed with Interswitch"}
              />
            </div>
          {/* <form
            method="POST"
            action="https://newwebpay.qa.interswitchng.com/collections/w/pay"
          >
            <input type="hidden" {...register("amount")} name="amount" />
            <input type="hidden" name="currency" value="566" />
            <input
              type="hidden"
              {...register("txn_ref")}
              name="txn_ref"
              id="tranRef"
            />
            <input
              type="hidden"
              {...register("merchant_code")}
              name="merchant_code"
            />
            <input
              {...register("pay_item_id")}
              type="hidden"
              name="pay_item_id"
            />
            <input
              {...register("site_redirect_url")}
              type="hidden"
              name="site_redirect_url"
            />
            <input type="hidden" name="display_mode" value="PAGE" />
            <div className={styles.btn}>
              <AppButton
                bRadius="6px"
                handleAction={() => {
                  handlePayment();
                }}
                width={"146px"}
                textColor="#FFFFFF"
                btnBg="#0072CE"
                btnText={"Proceed"}
              />
            </div>
          </form> */}
        </div>
      </>
    </div>
  );
}

export default PaymentPrompt;
